<template>
  <div>
    <p class="text-gray-400 my-1">Ключ авторизации для записи логов.</p>
    <p class="text-gray-400 my-1 mb-4">Можно создать только один активный ключ.</p>
    <div v-if="!loading">
      <div v-if="!error">
        <p class="text-green-400 mb-4">
          <span style="cursor: pointer;">{{ tokenData?.token }}</span>
        </p>
        <button @click.prevent="openModal" class="px-4 py-2 mt-2 text-white rounded transition-colors cursor-pointer" :class="tokenExist ? 'bg-blue-500 hover:bg-blue-600' : 'bg-green-500 hover:bg-green-600'">
          {{ tokenExist ? "Сменить" : "Создать"}}
        </button>
      </div>
      <p class="text-red-600" v-else>
        Ошибка
      </p>
    </div>
    <LoaderIcon v-else/>

    <ModalWindow
        :title="confirmModal.title"
        :weight2="sm"
        :show="confirmModal.show"
        @close="closeModal"
        @done="doneModal">
      <span v-html="removeMessage"></span>
    </ModalWindow>
  </div>
</template>

<script>
import ModalWindow from "@/components/modal/ModalWindow.vue";
import LoaderIcon from "@/components/LoaderIcon.vue";
//import Loading from '@/static/loading.svg';

export default {
  name: 'TokenBlock',
  components: {LoaderIcon, ModalWindow},
  data() {
    return {
      tokenData: null,
      error: null,
      loading: true,
      confirmModal: {
        title: "Создание нового ключа",
        message: "Создать новый ключ доступа?",
        show: false,
      }
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    removeMessage: function () {
      return this.tokenExist ? "Создание нового ключа повлечет <b>удаление</b> текущего.<br>Вам нужно будет заменить ключ на сервисах.<br><br><b>Продолжить изменение ключа?</b>" : "Будет создан ключ авторизации. Продолжить?"
    },
    tokenExist: function () {
      return this.tokenData?.id > 0;
    }
  },
  methods: {
    closeModal: function () {
      this.confirmModal.show = false;
    },
    doneModal: function () {
      this.confirmModal.show = false;
      this.createNewToken();
    },
    openModal: function () {
      this.confirmModal.show = true;
    },
    loadData: function () {
      console.log("load token")
      let c = this;
      c.tokenData = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/settings/api-token').then(function(response) {
        console.log(response.data);
        c.tokenData = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    },
    createNewToken: function () {
      console.log("load token")
      let c = this;
      c.tokenData = null;
      if (c.loading) {
        return;
      }
      c.loading = true;
      this.axios.post('/api/settings/api-token').then(function(response) {
        c.loading = false;
        console.log(response.data);
        c.tokenData = response.data.data;
      }).catch(function(err) {
        c.loading = false;
        console.log(err.status);
      });
    }
  }
}
</script>

<style scoped>

</style>